/**
 * Filters order data based on user role visibility rules.
 *
 * Rules:
 * - manufacturer.id === "aRxWCWK4BYvNKhqPjIVd" → visible only to admin
 * - manufacturer.invoicePrefix === "PDA" → visible only to admin and semiAdmin
 * - All other orders are visible to everyone.
 *
 * @param {Array} orders - Array of order objects from Firestore.
 * @param {Object} roles - Object with boolean flags: { admin, semiAdmin, devSpecialist }
 * @returns {Array} filteredOrders
 */
export function filterOrdersByRole(
  orders = [],
  { admin = false, semiAdmin = false, devSpecialist = false } = {}
) {
  if (!orders?.length) return []

  // Admins can see everything
  if (admin) return orders

  // Semi-admins and devSpecialists share same access level
  if (semiAdmin || devSpecialist) {
    return orders.filter((order) => order?.manufacturer?.id !== "aRxWCWK4BYvNKhqPjIVd")
  }

  // Regular users
  return orders.filter(
    (order) =>
      order?.manufacturer?.id !== "aRxWCWK4BYvNKhqPjIVd" &&
      order?.manufacturer?.invoicePrefix !== "PDA"
  )
}
